<script setup lang="ts">
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
})
</script>
<template>
  <router-link target="_blank" :to="{ path: `/blog/${props.blog.attributes.url}` }">
    <div
      :style="`background-image: url(${props.blog.attributes.thumbnail.data.attributes.url})`"
      class="h-60 w-full rounded-lg bg-cover bg-center bg-no-repeat"
    />
    <p class="mt-5 font-bold text-text-brand md:mt-7">
      {{ props.blog.attributes.topicHeading }}
    </p>
    <h6 class="mt-3 text-2xl font-medium sm:text-3xl md:mt-4 dark:text-[#D8DBDF]">
      {{ props.blog.attributes.title }}
    </h6>
  </router-link>
</template>
